var map = {
	"./ABC.svg": "1922",
	"./EUROSKLEP.svg": "7fc8",
	"./EURO_SKLEP.svg": "8c1e",
	"./GROSZEK.svg": "9174",
	"./M_SKLEPY.png": "275e",
	"./labels-thank-you.svg": "3b66",
	"./login.svg": "4ffb",
	"./my-business/advertising-materials.svg": "a646",
	"./my-business/agreement-template.svg": "9555",
	"./my-business/announcements.svg": "0e0a",
	"./my-business/contract-template-operational-manual.svg": "0325",
	"./my-business/drs.svg": "94f2",
	"./my-business/newspaper-materials.svg": "c20f",
	"./my-business/operations-manual.svg": "4eb0",
	"./my-business/partners-council.svg": "e304",
	"./my-business/purchasing-group-equal-in-business.svg": "f204",
	"./my-business/retr.svg": "4ad2",
	"./my-business/retrodiscounts-services-manual.svg": "881b",
	"./my-business/terms-of-business.svg": "5c1a",
	"./notifications.svg": "f670",
	"./promo-adv.png": "5f05",
	"./reports/service-2.svg": "81af",
	"./services/service-1.svg": "f1f2",
	"./services/service-2.svg": "e3f6",
	"./services/service-3.svg": "5ff3",
	"./services/service-4.svg": "d9db",
	"./welcome-ep.jpg": "940b",
	"./welcome-mpromo.jpg": "6541"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";